export default "__VITE_ASSET__npnAK1s5__"